import SButton from "components/Common/Button"

import React, { useState } from "react"
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"

import TextInputWithLabel from "components/Common/TextInputWithLabel"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import SeasonAction from "store/season-resource/actions"
import PaginationComponent from "components/newTables/PaginationComponent"
import RtwInventoryAPI from "helpers/rtw-inventory_backend_helper"

export default function ProductListModal({ config }) {
  const { productModalShown, setProductModalShown, handleProductAdd } = config
  const dispatch = useDispatch()

  const seasonPage = useSelector(state => state.seasonPage)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)

  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
  })

  const [filter, setFilter] = useState({
    number: "",
    supplierName: "",
    year: "",
    seasonId: "",
    seasonName: "",
  })

  const toggle = () => setProductModalShown(!productModalShown)

  const fetchData = async params => {
    const res = await RtwInventoryAPI.getListPage(params)
    setCount(res.data.totalPages)
    setData(res.data.content)
  }

  React.useEffect(() => {
    fetchData(params)
  }, [params.page])

  React.useEffect(() => {
    dispatch(SeasonAction.getList())
  }, [dispatch])

  const onChangeFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  return (
    <Modal isOpen={productModalShown} size="xl">
      <ModalHeader toggle={() => toggle()}>RTW在庫管理</ModalHeader>
      <ModalBody>
        <Row className="mb-2">
          <Col md={3}>
            <TextInputWithLabel
              label={"商品番号"}
              placeholder={""}
              value={filter.number}
              type="text"
              name="number"
              onChange={onChangeFilter}
            />
          </Col>
          <Col md={3}>
            <TextInputWithLabel
              label={"年度"}
              placeholder={""}
              value={filter.year}
              type="text"
              name="year"
              onChange={onChangeFilter}
            />
          </Col>
          <Col md={3}>
            <TextInputWithLabel
              label={"お取引先"}
              placeholder={""}
              value={filter.supplierName}
              type="text"
              name="supplierName"
              onChange={onChangeFilter}
            />
          </Col>
          <Col md={2}>
            <Label>シーズン</Label>
            <Select
              isLoading={seasonPage.list.loading}
              options={seasonPage.list.data.map(i => ({
                label: `${i.code} - ${i.name}`,
                value: i.id,
              }))}
              defaultValue={{
                value: filter.seasonId,
                label: filter.seasonName,
              }}
              value={{ value: filter.seasonId, label: filter.seasonName }}
              onChange={e => {
                if (e) {
                  setFilter({
                    ...filter,
                    seasonId: e.value,
                    seasonName: e.label,
                  })
                } else {
                  setFilter({ ...filter, seasonId: "", seasonName: "" })
                }
              }}
              isClearable
            />
          </Col>
          <Col className="d-flex align-content-end flex-wrap justify-content-end">
            <SButton
              className="button"
              onClick={() =>
                fetchData({
                  ...params,
                  page: 0,
                  number: filter.number,
                  supplierName: filter.supplierName,
                  year: filter.year,
                  seasonId: filter.seasonId,
                  seasonName: filter.seasonName,
                })
              }
            >
              検索
            </SButton>
          </Col>
        </Row>

        <Table bordered>
          <thead>
            <tr className="text-center">
              <th>商品番号</th>
              <th>商品名</th>
              <th>お取引先</th>
              <th>年度</th>
              <th>シーズン</th>
              <th>サイズ</th>
              <th>受注数</th>
              <th>現在製作中</th>
              <th>実在庫数</th>
              <th>理論在庫</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((product, idx) => (
                <tr key={idx}>
                  <td>{product.number}</td>
                  <td>{product.productName}</td>
                  <td>{product.supplierName}</td>
                  <td>{product.year}</td>
                  <td>{product.seasonCode}</td>
                  <td>{product.size}</td>
                  <td>{product.numberOfOrders}</td>
                  <td>{product.currentlyInProduction}</td>
                  <td>{product.actualInventory}</td>
                  <td>
                    {product.actualInventory < product.numberOfOrders && "▲"}{" "}
                    {product.theoreticalStock}
                  </td>
                  <td className="text-center">
                    <SButton
                      className="button"
                      onClick={() => {
                        handleProductAdd(product)
                      }}
                    >
                      選択
                    </SButton>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        <Col sm="12" className="d-flex align-items-center justify-content-end">
          <PaginationComponent
            pagesCount={count}
            currentPage={params.page}
            setCurrentPage={params => {
              setParams({ ...params, ...filter })
            }}
            params={params}
          />
        </Col>
      </ModalBody>
    </Modal>
  )
}
